import { captureException } from '@sentry/browser';
import { loadRecordHit } from 'js/utils/loadRecordHit';
import trackClick from 'js/utils/trackClick';
import {
  ImpressionEntity,
  watchImpressions,
} from 'js/utils/impressions/watchImpressions';

export function trackArticleEngagement(): void {
  const root = document.getElementById('sap-article-body');
  const data = root?.dataset.sapAnalytics;
  if (!root || !data) return;
  const analytics: { workId: number } = JSON.parse(data);

  void loadRecordHit()
    .then(async () => {
      if (!window.Aedu?.hit_data?.id) return;
      if (document.hidden) {
        await new Promise<void>((resolve) => {
          const onVisible = () => {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVisible);
            resolve();
          };
          document.addEventListener('visibilitychange', onVisible);
        });
      }
      const sections: Record<string, string> = {
        actions: '.sap__header-mobile-top-row',
        abstract: '#sap-abstract',
        metrics: '#article-stats',
        references: '.sap__ref-list h2',
        citation: '#sap-evaluation-citation h2',
      };
      const watchSection = (section: string, element: HTMLElement) =>
        watchImpressions(element, {
          source: `sap_section_${section}`,
          entity_id: analytics.workId,
          entity_type: ImpressionEntity.Work,
          threshold: 0,
          extra: { section },
        });
      Object.entries(sections).forEach(([section, selector]) => {
        const element = root.querySelector<HTMLElement>(selector);
        if (element && (section !== 'metrics' || element.textContent?.trim()))
          watchSection(section, element);
      });
      const actions: [string, string][] = [
        ['pdf_download_click', '[id^="DownloadButton-react-component"] a'],
        ['share_open', '[id^="ShareButton-react-component"] button'],
        ['affiliations_toggle', '#affiliation-list-link'],
        [
          'supplementary_download',
          '.sap-evaluation__supplementary-download, .sap__supplementary-files-download-link a',
        ],
        ['reference_doi', '.sap__ref-content a[href*="doi.org/"]'],
        ['alerts_open', 'a[href*="/journals/"][href*="/subscribe"]'],
        ['contents_jump', '#article-table-of-contents a'],
      ];
      const action = (name: string) =>
        trackClick({
          source: 'sap_article_action',
          entityId: analytics.workId,
          extra: { action: name },
        });
      document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element) || target.closest('dialog')) return;
        const match = actions.find(([, selector]) => target.closest(selector));
        if (match) action(match[0]);
      });
      root.addEventListener('change', (event) => {
        if ((event.target as Element).id === 'sap-evaluation-jump')
          action('contents_jump');
      });
    })
    .catch(captureException);
}
